import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';

import Footer from 'src/components/Footer';
import GeneralBanner from 'src/components/GeneralBanner';
import Navbar from 'src/components/Navbar';
import Sidebar from 'src/components/Sidebar';

import TextBody from 'src/components/TextBody';
import { Colors, LoadIcon, WhatsIcon } from 'src/styles/DesignSystem';
import Cta from 'src/components/Cta';
import Especialidades from 'src/components/Especialidades';
import MarcasSlider from 'src/components/MarcasSlider';
import InfraSlider from 'src/components/InfraSlider';

import banhoBg from 'src/assets/pages/banho-tosa-bg.webp';
import lojaBg from 'src/assets/pages/loja-bg.webp';
import clinicaBg from 'src/assets/pages/clinica-bg.webp';


const Servicos = () => {

    // Controles do menu
    const [isOpen, setIsOpen] = useState(false);
    const toggle = ()=>{
        setIsOpen(!isOpen);
    }

    // Controles de dados
    const idServico = useLocation().state.id;
    const slugServico = useParams();

    const [servico, setServico] = useState({});
    const [marcas, setMarcas] = useState({});
    const [especialidades, setEspecialidades] = useState([]);
    const [images, setImages] = useState([]);
    const imagesDefault = ['https://hipermercadodasracoes.com/system/static/media/infra-img.f72e4a3f6e79722297f1.png'];
    const [bgImage, setBgImage] = useState();

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect( () => {
        const getData = () =>{
            // Reseta os estados
            setServico({});
            setImages([]);
            setIsLoaded(false);

            // fetch do servico
            axios.get(`https://hipermercadodasracoes.com/system/wp-json/wp/v2/servicos/${idServico}`)
            .then( (res) => {
                setServico(res.data);
                if(res.data.acf.carrossel_img_01)
                setImages(arr => [...arr, res.data.acf.carrossel_img_01]);

                if(res.data.acf.carrossel_img_02)    
                    setImages(arr => [...arr, res.data.acf.carrossel_img_02]);

                if(res.data.acf.carrossel_img_03)
                    setImages(arr => [...arr, res.data.acf.carrossel_img_03]);

                if(res.data.acf.carrossel_img_04)    
                    setImages(arr => [...arr, res.data.acf.carrossel_img_04]);

                if(res.data.acf.carrossel_img_05)
                    setImages(arr => [...arr, res.data.acf.carrossel_img_05]);

                if(res.data.acf.carrossel_img_06)    
                    setImages(arr => [...arr, res.data.acf.carrossel_img_06]);
                
                switch(res.data.slug){
                    case 'loja': setBgImage(lojaBg); break;
                    case 'clinica-veterinaria': setBgImage(clinicaBg); break;
                    case 'banho-e-tosa': setBgImage(banhoBg); break;
                    default: setBgImage(banhoBg);
                }
                setIsLoaded(true);
            });
        }

        getData();
    }, [setServico, slugServico]);


    useEffect( () => {
        setIsLoaded(false);
        if(Object.keys(servico).length > 0){
            const especsSort = () =>{
                setEspecialidades([]);
                servico.acf.especialidades.forEach( espec => {
                    const getEspec = async () => {
                        let res = await axios.get(`https://hipermercadodasracoes.com/system/wp-json/wp/v2/especialidades/${espec.ID}`);
                        let ordered = {
                            id: res.data.id,
                            title: res.data.title.rendered,
                            icon: res.data.acf.icon.url,
                        }        
                        setEspecialidades(arr => [...arr, ordered]);
                        
                    };
                    getEspec();
                    
                });
            }
            
            const marcasSort = () =>{
                setMarcas([]);
                if(servico.acf.marcas){
                    servico.acf.marcas.forEach( marca => {
                        const getMarca = async () => {
                            let res = await axios.get(`https://hipermercadodasracoes.com/system/wp-json/wp/v2/marcas/${marca.ID}`);
                            let marcasOrdered = {
                                id: res.data.id,
                                title: res.data.title.rendered,
                                logo: res.data.acf.logo.url,
                            }        
                            setMarcas(arr => [...arr, marcasOrdered]);
                        };
                        getMarca();
                    });
                }
                
            }

            especsSort();
            marcasSort();
            setIsLoaded(true);
        }
        
    }, [servico, setEspecialidades, setMarcas]);

    if(!isLoaded){
        return(
          <>
            <LoadIcon />
          </>
        )
    }
    else{
        especialidades.sort(function(a, b) {
            if(a.title < b.title) {
              return -1;
            } else {
              return true;
            }
        });
    }

    return (
        <>
            {
                !isLoaded ?
                    <LoadIcon />
                :
                <>
                    <Navbar isOpen = {isOpen} toggle={toggle} page="servicos"/>
                    <Sidebar isOpen = {isOpen} toggle={toggle} page='servicos'/>

                    <GeneralBanner wd={15} bgImage={bgImage} title={servico.title.rendered}/>
                    <TextBody 
                        text={servico.acf.descricao}
                        cta={
                            <Cta onclick={ ()=>window.location.href = servico.acf.botao_link }>
                                {servico.acf.botao_text}
                                <WhatsIcon />
                            </Cta>
                        }
                    />
                    
                    {
                        /* Verifica se há especialidades cadastradas */               
                        especialidades.length > 0 ? <> <Especialidades especialidades={especialidades}/> </> : <></>
                    }

                    {
                        /* Verifica se há marcas cadastradas */  
                        marcas.length > 0 ? <> <MarcasSlider marcas={marcas}/> </> : <div className='clearfix'></div>
                    }

                    {  
                        /* Verifica se há Imagens cadastradas */  
                        images.length > 0 ? 
                            <> 
                                <Footer 
                                    firtsComponent={<InfraSlider mt={-15} images={images} />} 
                                    bgColor = {Colors.lighBrown}
                                />
                            </> 
                        : <>
                            <Footer 
                                firtsComponent={<InfraSlider mt={-15} images={imagesDefault} />} 
                                bgColor = {Colors.lighBrown}
                            />
                        </>
                    }

                    
                </>
            }
        </>
    )
}

export default Servicos;